import { useMemo } from "react";
import {
  CellClassParams,
  CheckboxEditorModule,
  ClientSideRowModelModule,
  ColDef,
  ColGroupDef,
  ModuleRegistry,
  ValidationModule
} from "ag-grid-enterprise";
import { coldefSingleField } from "entity-app/shared-components/log-render-components/col-defs";
import { CellValueRendererWithEditIcon } from "components/cell-renders";
import { MaterialExtractSpecType } from "../model";
import activeInlogCellRenderer from "../components/checkbox/active-inlog-cell-renderer";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  CheckboxEditorModule,
  ...(process.env.NODE_ENV !== "production" ? [ValidationModule] : [])
]);

export const useMaterialLogAgGrid = (props: {
  pageData: {
    materialHeaderMap: any;
  };
}) => {
  const { materialHeaderMap } = props.pageData;

  const isGridCellEditable = (
    params: CellClassParams<any, any>
  ): boolean | undefined => {
    return !!params?.colDef?.editable;
  };

  const defaultColDef = useMemo(
    () =>
      ({
        sortable: true,
        editable: false,
        filter: true,
        resizable: true,
        menuTabs: ["filterMenuTab"],
        minWidth: 100,
        cellRenderer: CellValueRendererWithEditIcon,
        cellEditorPopup: false
      } as ColDef<MaterialExtractSpecType>),
    []
  );

  const columnDefs = useMemo(
    () =>
      [
        coldefSingleField({
          field: "tag",
          headerName: materialHeaderMap?.tag_name || "Tag",
          width: 160
        }),
        coldefSingleField({
          field: "title",
          headerName: materialHeaderMap?.name || "Material Name",
          width: 320
        }),
        coldefSingleField({
          field: "table_title",
          headerName: "Schedule Name",
          width: 260
        }),
        coldefSingleField({
          field: "manufacturer",
          headerName: materialHeaderMap?.manufacturer || "Manufacturer",
          width: 240
        }),
        coldefSingleField({
          field: "location",
          headerName: materialHeaderMap?.locations || "Location",
          width: 230
        }),
        coldefSingleField({
          field: "active",
          headerName: "In Log",
          width: 120,
          cellRenderer: activeInlogCellRenderer,
          valueGetter: ({ data }: any) => {
            return data.feature_materials_aggregate?.aggregate?.count
              ? "In Log"
              : "Blank";
          }
        })
      ] as (
        | ColDef<MaterialExtractSpecType>
        | ColGroupDef<MaterialExtractSpecType>
      )[],
    [
      materialHeaderMap?.locations,
      materialHeaderMap?.manufacturer,
      materialHeaderMap?.name,
      materialHeaderMap?.tag_name
    ]
  );
  return {
    columnDefs,
    defaultColDef,
    isGridCellEditable
  };
};
